module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_badge_iron-5815a29cd4235db7b9519bccb6097407.svg";